import cidrRegex from "cidr-regex";
import ipRegex from "ip-regex";
import isValidDomain from "is-valid-domain";

export default {
  install(Vue) {
    /**
     * Checks form input validity
     *
     * @returns boolean
     * @param inputModel vuelidate form model for particular field
     * @param withValidState whether or not to set an "is-valid" state
     */
    Vue.prototype.$validateState = (inputModel, withValidState = false) => {
      const { $dirty, $error } = inputModel;
      return withValidState
        ? $dirty
          ? !$error
          : null
        : $dirty && $error
        ? false
        : null;
    };
    Vue.prototype.$isQualifiedDomain = (domain) => {
      return isValidDomain(domain, { subdomain: true });
    };
    Vue.prototype.$validPassword = (password) => {
      return (
        password === "" ||
        password === undefined ||
        (/[a-zA-Z]/.test(password) &&
          (/[#?!@$%^&*-]/.test(password) || /[0-9]/.test(password)))
      );
    };
    Vue.prototype.$containsSpecial = (word) => {
      return (
        word === "" || word === undefined || /^[a-zA-Z0-9\s_\-.]*$/.test(word)
      );
    };
    Vue.prototype.$cidrOrIP = (ip) => {
      return (
        ipRegex.v4({ exact: true }).test(ip) ||
        ipRegex.v6({ exact: true }).test(ip) ||
        cidrRegex.v4({ exact: true }).test(ip) ||
        cidrRegex.v6({ exact: true }).test(ip)
      );
    };
  },
};
